<template>
   <div>
        <Header :viewDeals="viewDeals" />
        <ModuleMenu 
            :moduleKey="$route.params.mid"
            :projectId="$route.params.pid"
            @quickViewDeals="viewDeals = !viewDeals" />
        
        <v-container class="container_width pb-12">
            <div class="text-center my-10" style="width: 100%">
                <img :src="require(`@/assets/submittedQuestionnaire.png`)" :alt="`Submitted ${mod_info.module_name} Questionnaire`">
            </div>

            <div class="my-10 subtitle-1 text-center">
                <div class="sansation_title my-2">
                    <p>Thank You!</p>
                    <p>You&apos;ve Completed {{ $route.params.mid == 'buyer' ? 'your Buyer Profile!' : 'and Submitted your Questionnaire!' }}</p>
                </div>
                <div v-if="$route.params.mid == 'buyer'" class="mx-12">
                    <p class="my-2 px-4">Thank you for completing your buyer profile. You are now eligible to express interest on active listings.</p>
                    <p>You can also view and edit your buyer profile answers by clicking the button below.</p>
                </div>
                <div v-else-if="$route.params.mid == 'merger-party-data'" class="mx-12">
                    <p class="my-2 px-4">
                        <span class="sansation_subtitle">Thank you for completing your pre-merger questionnaire!</span><br>
                        <span>The next step is to complete the main questionnaire for your merger project.</span><br>
                        <span>You may close this tab now</span>
                    </p>
                </div>
                <div v-else>
                    <p class="my-2 px-4">
                        <span class="sansation_subtitle">Our team is reviewing the data you have provided.</span><br>
                        <span v-if="!$route.params.mid.includes('-starter')">
                            The next step is to schedule a call with your project team. Scheduling is done through the appropriate Roadmap stage.<br>
                            Click the button below to go to the Roadmap and schedule right away. Alternatively, you can schedule a call with reception at (503) 427-9910.
                        </span>
                    </p>
                    <p v-if="!$route.params.mid.includes('-starter')">Otherwise, we will be in touch with you soon to go over next steps.</p>
                </div>
            </div>
            <div class="my-10 text-center" v-if="readyToLoadTeam">
                <div v-if="$route.params.mid == 'buyer'">
                    <router-link :to="`/buyer_listings`" push class="button_link">
                        <v-btn color="primary" dark class="ml-6 d-inline">Express Interest</v-btn>
                    </router-link>
                    <router-link :to="`/module_questionnaire/${$route.params.mid}/${$route.params.pid}`" push class="button_link">
                        <v-btn color="primary" outlined class="ml-6 d-inline">Review Your Buyer Profile</v-btn>
                    </router-link>
                </div>
                <div v-else-if="$route.params.mid == 'merger-party-data'">
                    <v-btn 
                        color="primary" 
                        outlined 
                        class="d-inline"
                        @click="closeWindow()">
                        Close this Tab
                    </v-btn>
                </div>
                <div v-else>
                    <!-- <a v-if="!$route.params.mid.includes('-starter')" :href="mod_info.srg_team.teamcal" target="_blank" class="button_link">
                        <v-btn color="primary" dark class="mr-6 d-inline">Schedule a Call</v-btn>
                    </a> -->
                    <router-link :to="`/module_roadmap/${$route.params.mid}/${$route.params.pid}`" push class="button_link">
                        <v-btn color="primary" outlined class="ml-6 d-inline">View Project Roadmap</v-btn>
                    </router-link>
                    <router-link :to="`/module_questionnaire/${$route.params.mid}/${$route.params.pid}`" push class="button_link">
                        <v-btn color="primary" outlined class="ml-6 d-inline">Review Your Questionnaire</v-btn>
                    </router-link>
                </div>
            </div>
            <div class="my-10 text-center" v-if="readyToLoadTeam">
                	<div class="mb-2 avenir_book project_title">Contact Us: <!-- Our support team is here to answer any questions and help keep your project on track. --></div>

                    <v-tooltip top content-class="contact_tooltip">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn 
                                icon
                                color="primary"
                                class="mx-6"
                                v-bind="attrs"
                                v-on="on"
                                target="_blank"
                                href="mailto:info@successionresourcegroup.com">
                                <v-icon>mdi-email</v-icon>
                            </v-btn>                            
                        </template>
                        <span>Email</span>
                    </v-tooltip>
                    
                    <v-tooltip top content-class="contact_tooltip">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn 
                                icon
                                color="primary"
                                class="mx-6"
                                v-bind="attrs"
                                v-on="on"
                                @click="beginChat">
                                <v-icon>mdi-chat-question</v-icon>
                            </v-btn>
                        </template>
                        <span>Chat</span>
                    </v-tooltip>

                    <v-tooltip top content-class="contact_tooltip">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn 
                                icon
                                color="primary"
                                class="mx-6"
                                v-bind="attrs"
                                v-on="on"
                                @click="beginCall">
                                <v-icon>mdi-phone</v-icon>
                            </v-btn>
                        </template>
                        <span>Call</span>
                    </v-tooltip>
            </div>
        </v-container>
   </div>
</template>


<script>
    import axios from 'axios'
    import Cookie from 'js-cookie'
    import appUrls from '../helpers/environment'

    import Header from './Header'
    import ModuleMenu from './ModuleMenu'

    export default {
        name: 'SubmittedQuestionnaire',
        components: {
            Header,
            ModuleMenu
        },
        data () {
            return {
                readyToLoad: false,
                readyToLoadTeam: false,
                mod_info: [],
                viewDeals: false,
            }
        },
        mounted() {
            this.getModuleInfo()
        },
        methods: {
            getModuleInfo: function () {
                axios.get(`${appUrls.api}/api/module_info/${this.$route.params.mid}`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                })
                .then( res => {
                    // console.log(res.data.info)
                    if(res.data.outcome){
                        this.mod_info = res.data.info;
                        setTimeout(() => {
                            this.readyToLoad = true;
                            if( this.mod_info.srg_team != null) this.readyToLoadTeam = true;
                        }, 500);
                    }
                    //console.log(this.mod_info)
                })
                .catch(function (error) {
                    console.log(error);
                });
            },

            beginChat: function () {                
                if (window.HubSpotConversations) {
                    // console.log('The api is ready already');
                    window.HubSpotConversations.widget.open()
                } else {
                    window.hsConversationsOnReady = [
                        () => {
                        // console.log('Now the api is ready');
                        window.HubSpotConversations.widget.open()
                        }
                    ];
                }
            },

            beginCall: function () {
                window.open('tel:+15034279910')
            },

            closeWindow: function () {
                window.close()
            }
        }
    }
</script>


<style scoped>
    .v-input {
        opacity: 0.9;
        color: blue;
    }
    .min_height {
        min-height: 70vh;
    }
    label.v-label {
        color: blue !important;
    }
    .contact_tooltip {
        font-size: .8rem !important;
        padding: .25rem .8rem !important;
        margin-top: .2rem !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SubmittedQuestionnaire.vue